export default {
  sm_storage_losses: [],
  sm_storage_loss: null,
};
